export default "__VITE_ASSET__Cm7qmd_x__"